const PAGE_TYPES = {
  PROFILE: 'PROFILE',
  REFUND_RAISE_REQUEST: 'REFUND_RAISE_REQUEST',
  SUPPLIER_SETTINGS: 'SUPPLIER_SETTINGS',
  GST_INVOICE_REPORT: 'GST_INVOICE_REPORT',
  COMMISSION_REPORT: 'COMMISSION_REPORT',
};

export {PAGE_TYPES};
export default {PAGE_TYPES};
